import React from "react";
import { Box, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

export default function RecordNotFound() {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {/* Icon */}
      <SearchOffIcon
        sx={{
          fontSize: 90,
          color: "#c4c4c4",
          mb: 2,
        }}
      />

      {/* Title */}
      <Typography
        sx={{
          fontSize: 32,
          fontWeight: 600,
          color: "#333",
          mb: 1,
        }}
      >
        No Records Found
      </Typography>

      {/* Subtitle */}
      <Typography
        sx={{
          fontSize: 16,
          color: "#777",
          maxWidth: 500,
        }}
      >
        No data available at the moment. Please check back later.
      </Typography>
    </Box>
  );
}
